import localization from "../../../../config/localization";
import { SidebarDivider } from "../SidebarDivider";
import { SidebarItem } from "../SidebarItem";

interface ProfileMenuProps {
  handleNavigate: (path: string) => void;
}

export function ProfileMenu({
  handleNavigate,
}: ProfileMenuProps) {
  const profieItems = [
    {
      imgSrc: "/icons/ic-sidebar-profile.svg",
      label: localization.profile,
      onClick: () => handleNavigate("/profile"),
    },
    {
      imgSrc: "/icons/ic-sidebar-inbox.svg",
      label: localization.inbox,
      onClick: () => handleNavigate("/inbox"),
    },
    {
      imgSrc: "/icons/ic-sidebar-verification.svg",
      label: localization.verification,
      onClick: () => handleNavigate("/verification"),
    },
    {
      imgSrc: "/icons/ic-sidebar-responsible-gaming.svg",
      label: localization["responsible-gaming"],
      onClick: () => handleNavigate("/responsible-gaming"),
    },
  ];

  return (
    <>
      <div className="mx-4 border border-[#2E2E2E] bg-[#0F0F0F] rounded-xl overflow-hidden">
        {profieItems.map((item, index) => (
          <div key={item.label}>
            <SidebarItem
              showArrow={true}
              imgSrc={item.imgSrc}
              label={item.label}
              onClick={item.onClick}
            />
            {index !== profieItems.length - 1 && <SidebarDivider />}
          </div>
        ))}
      </div>
    </>
  );
}
